import { TextField } from '@mui/material'
import { GRID_FORM_CONFIG_T } from '../../../common/FormGenerator'
import { TextFieldEmail, TextFieldPassword } from '../AuthForm/style'
import { PasswordInput } from '../AuthForm/PasswordInput'

export type PasswordAuthFormBlockName = 'login' | 'password'

export const loginConfig: GRID_FORM_CONFIG_T<{ login: string }> = [
    [
        {
            id: 1,
            controllerName: 'login',
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: 'Логин',
                size: 'small',
                sx: TextFieldEmail,
                fullWidth: true,
            }),
        },
    ],
]

export const passwordConfig: GRID_FORM_CONFIG_T<{ password: string }> = [
    [
        {
            id: 2,
            controllerName: 'password',
            RenderElement: PasswordInput,
            renderProps: () => ({
                placeholder: 'Пароль',
                size: 'small',
                sx: TextFieldPassword,
                fullWidth: true,
            }),
        },
    ],
]

const formConfigs: Record<PasswordAuthFormBlockName, GRID_FORM_CONFIG_T<unknown>> = {
    login: loginConfig as GRID_FORM_CONFIG_T<unknown>,
    password: passwordConfig as GRID_FORM_CONFIG_T<unknown>,
}

export const getFormConfig = (blockName: PasswordAuthFormBlockName) => formConfigs[blockName]
